import { render, staticRenderFns } from "./InterpretationView.vue?vue&type=template&id=c9ec98f6&"
import script from "./InterpretationView.vue?vue&type=script&lang=js&"
export * from "./InterpretationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports